import { RouteErrorBoundary } from "@/components/routing/RouteErrorBoundary";
import Support from "@/pages/Support";
import Contact from "@/pages/Contact";
import ContactSales from "@/pages/ContactSales";
import SearchResults from "@/pages/SearchResults";
import CommunityForum from "@/pages/CommunityForum";
import VideoConsultation from "@/pages/VideoConsultation";

export const supportRoutes = [
  {
    path: "/support",
    element: <Support />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/contact",
    element: <Contact />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/contact-sales",
    element: <ContactSales />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/search",
    element: <SearchResults />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/community-forum",
    element: <CommunityForum />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/video-consultation",
    element: <VideoConsultation />,
    errorElement: <RouteErrorBoundary />,
  },
];